import styled from "styled-components";
import { ToggleSelect } from "@loanbossinc/component-library";

export const StyledSecondaryButtonWrapper = styled.div`
  float: right;
`;

export const OuterWrapper = styled.div`
  background: ${props => (props.isPrivate ? "#FFFFFF" : "#FAD4CE")};
  border: 1px solid;
  border-color: ${props => (props.isPrivate ? "#0F9AD6" : "#C40A0A")};
  box-sizing: border-box;
  border-radius: 8px;

  .item-actions {
    padding: 24px;
    border-top: 1px solid #DADCE0;
  }

  .item-content {
    padding: 20px 24px;
    display: flex;
  }

  &:not(:first-child) {
    margin-top: 24px;
  }
`;

export const DeleteWrapper = styled.div`  
  float: right;
  cursor: pointer;
  color: #5F6368;
  margin-left: 24px;
`;

const baseFont = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
`;

export const FileWrapper = styled(baseFont)`
  color: #000000;
  margin-right: auto;
`;

export const StyledToggleSelect = styled(ToggleSelect)`
  &&{
    .Mui-selected {
      background-color: ${props => (props.isPrivate ? "#0F9AD6" : "#C40A0A")};
      color: #fff;
    }
  }
`;
